export const types = {
  START_IMPORT_STATUS_POLLING: 'START_IMPORT_STATUS_POLLING',
  GET_IMPORT_STATUS_PROCESSING: 'GET_IMPORT_STATUS_PROCESSING',
  GET_IMPORT_STATUS_SUCCESS: 'GET_IMPORT_STATUS_SUCCESS',
  GET_IMPORT_STATUS_FAILURE: 'GET_IMPORT_STATUS_FAILURE',
  CANCEL_IMPORT_STATUS_POLLING: 'CANCEL_IMPORT_STATUS_POLLING',
};
